"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTemplate = exports.useBrand = exports.useBrandToken = void 0;
var react_1 = require("react");
var lift_brand_token_provider_1 = require("./lift-brand-token.provider");
//O nome atual deste hook não condiz muito com o que ele faz, necessário na V2 alterar para algo melhor
var useBrandToken = function () {
    return (0, react_1.useContext)(lift_brand_token_provider_1.LftProviderContext).tokens;
};
exports.useBrandToken = useBrandToken;
var useBrand = function () {
    return (0, react_1.useContext)(lift_brand_token_provider_1.LftProviderContext).brand;
};
exports.useBrand = useBrand;
var useTemplate = function () {
    return (0, react_1.useContext)(lift_brand_token_provider_1.LftProviderContext).template;
};
exports.useTemplate = useTemplate;
